import { useTranslate } from '@tolgee/react';
import { Form, Input, InputNumber } from 'antd';
import { CountryFlagIcon } from 'components/CountryFlagIcon';
import { regionMonetaryUnitMap } from 'services/config/region';
import toLowerCase from 'utils/toLowerCase';
import { FV } from './share';
import { useFormikContext } from 'formik';
import FormField from 'components/FormField';
import { isNil, toNumber, toString } from 'lodash-es';
import { isAlphanumeric } from 'utils/validator/string';
import styled from '@emotion/styled';

export const LiveCode = ({ disabled = false }: { disabled?: boolean }) => {
  const { t } = useTranslate();

  const {
    values: { stores },
  } = useFormikContext<FV>();

  return (
    <>
      <LiveCodeInputWrap label={t('直播间暗号')}>
        <p className="text-content-200 text-xs mt-2">{t('activity_form_live_code_desc1')}</p>
        <FormField<FV['liveCode']>
          name="liveCode"
          validateTrigger="onBlur"
          validate={(value) => {
            if (value && !isAlphanumeric(value)) {
              return t('error_alphanumeric');
            }
            return Promise.resolve();
          }}
        >
          {({ field }) => (
            <Input
              {...field}
              maxLength={8}
              className="!w-48"
              disabled={disabled}
              placeholder={t('请输入直播间暗号')}
            />
          )}
        </FormField>
        <p className="text-content-200 text-xs pt-2 mb-0">{t('activity_form_live_code_desc2')}</p>
      </LiveCodeInputWrap>
      <FormField<FV['liveCodeDiscount']> name="liveCodeDiscount" label={t('暗号优惠券金额')}>
        {({ field: { value, onChange, onBlur } }) => {
          const [{ region = undefined } = {}] = stores;
          return (
            <InputNumber
              className="!w-48"
              disabled={disabled}
              addonAfter={region ? regionMonetaryUnitMap[toLowerCase(region)] : undefined}
              prefix={region ? <CountryFlagIcon region={region} /> : undefined}
              min={1}
              max={99999}
              value={value && toNumber(value)}
              formatter={(value) => {
                const reg = /^(-)*(\d+)\.(\d\d).*$/;
                return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '').replace(reg, '$1$2.$3');
              }}
              placeholder={t('请输入优惠金额')}
              onChange={(value) => onChange(isNil(value) ? '' : toString(value))}
              onBlur={onBlur}
            />
          );
        }}
      </FormField>
    </>
  );
};

const LiveCodeInputWrap = styled(Form.Item)`
  .ant-row.ant-form-item {
    margin: 0;
  }
`;
